import { ServerEnv } from 'shared/sharedTypes/common/misc';
import isGovOrIl5EnvCommon from 'shared/sharedCode/isGovOrIl5EnvCommon';

/**
 * Centralized visibility rules for FFMenu items.
 *
 * Each menu item passes an `activeKey` to `genericRender`. To hide an item in a
 * class of environments, add its `activeKey` to the relevant set below
 *
 * Precedence: these rules run in `genericRender` AFTER an item's own `gate`, so a
 * gate that already hides an item still wins; this only removes items that would
 * otherwise be shown.
 */

/**
 * Items hidden in all GovCloud and IL5 environments
 * (govqa, govqak8s, govstgk8s, secondfront/il5*, etc).
 *
 * TEMPORARY (MAENV-796): these are hidden only because the features are not
 * part of the il5 v1 deployment. Remove each key as its feature is released in
 * il5 prod
 */
const HIDDEN_IN_GOV_OR_IL5: ReadonlySet<string> = new Set([
    'fleet_tracking',
    'jetfuelx',
    'logbook',
    'checklist',
    'billing',
    'marketplace',
]);

/**
 * Returns true when a menu item identified by `activeKey` should be hidden for the
 * given server environment.
 */
export function isMenuItemHiddenForEnv(
    activeKey: string | undefined,
    serverEnv: ServerEnv | undefined
): boolean {
    if (!activeKey) return false;
    if (isGovOrIl5EnvCommon(serverEnv) && HIDDEN_IN_GOV_OR_IL5.has(activeKey)) {
        return true;
    }
    return false;
}
